import React from 'react';
import { IProps, IState } from './types';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType } from 'constants/enums/insType.enum';
import { insProcessCarStep, insProcessCarStepIcon } from 'constants/enums/insProcessCar.enum';
import ProcessBar from 'components/InsureProcess/ProcessBar';
import { IStepElems } from 'components/InsureProcess/ProcessBar/types';
import InsureProcessVehicleOwnerInfo from 'components/InsureProcess/Vehicle/InsureProcessVehicleOwnerInfo';
import InsureProcessVehicalInfo from 'components/InsureProcess/Vehicle/InsureProcessVehicalInfo';
import InsureProcessSelect from 'components/InsureProcess/Vehicle/InsureProcessSelect';
import InsureProcessFill from 'components/InsureProcess/Vehicle/InsureProcessFill';
import InsureProcessPreview from 'components/InsureProcess/Vehicle/InsureProcessPreview';
import InsureProcessPayment from 'components/InsureProcess/Vehicle/InsureProcessPayment';
import InsureProcessSuccess from 'components/InsureProcess/Vehicle/InsureProcessSuccess';
import SliderBoundless from 'components/SliderBoundless';
import service from 'bff/services/carProductService';
import apiCommonService from 'bff/services/commonService';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import {
  IVehicleOwnerInfoFormValue,
  IVehicleOwnerInfoState
} from 'constants/models/components/insureProcessCar/vehicleOwnerInfo';
import sweetAlertService from 'utils/sweetAlertService';
import { RouterSettings } from 'constants/models/routerSettings';
import memberProfileService from 'bff/services/memberProfileService';
import { MemberProfile } from 'bff/models/member';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
import { IVehicleInfoFormValue, IVehicleInfoState } from 'constants/models/components/insureProcessCar/vehicleInfo';
import {
  InprocessSelectFormValue,
  InprocessSelectState
} from 'constants/models/components/insureProcessCar/inprocessSelect';
import {
  InsureProcessFillFormValue,
  InsureProcessFillState
} from 'constants/models/components/insureProcessCar/insureProcessFill';
import OTPVerificationForm from 'components/OTPVerificationForm';
import { OTPInfo } from 'bff/models/login';
import { Activity, Code } from 'bff/models/info';
import { SactionType } from 'constants/enums/sactionType.enum';
import { ApplyType } from 'constants/enums/applyType.enum';
import { IPaymentFormValue, IPaymentState } from 'constants/models/components/insureProcessCar/payment';
import _ from 'lodash';
import { NationalType } from 'constants/enums/nationalType.enum';
import {
  IVehiclePreviewFormValue,
  IVehiclePreviewState
} from 'constants/models/components/insureProcessCar/vehiclePreview';
// import moment from 'moment';
import moment from 'moment-timezone';
import { InsureProcessTemp } from 'constants/models/insureProcessTemp';
import { ConstrainContent, CriteriaContent, PolicyItemListContent } from 'bff/models/product/vehicleItemList';
import { DataLayerArgs } from 'react-gtm-module';
import { helperArgGTM, pushGTM } from 'plugins/gtmService';

const initState: IState = {
  insTypeName: '',
  step: 0 as insProcessCarStep,
  insTypeId: InsType.Car,
  prodId: '',
  programId: '',
  UICodes: new Array(0),
  vehicleLimit: [],
  nationalityVSysOpts: new Array(0),
  pNoFormat: [],
  vehicleCars: new Array(0),
  isBirthdayErr: false,
  tempVehicleOwnerInfo: {},
  tempVehicleInfo: {},
  tempSelect: {},
  tempFill: {},
  tempPreview: {},
  tempPayment: {},
  boPayby: {
    POLICY_FEE: 0,
    INS_TYPE_ID: '',
    APPLY_NO: '',
    BC_TYPE: '',
    PROD_ID: '',
    PAYER_LIST: [],
    END_DATE: '',
    START_DATE: '',
    START_HOUR: '',
    POLICY_DELIVERY: '',
    PROD_NAME: '',
    CO_END_DATE: '',
    CAR_LICENSE: '',
    CO_START_DATE: '',
    VO_START_DATE: '',
    VO_END_DATE: '',
    CAR_SURVEY_STATUS: ''
  },
  policyAddReq: undefined
};

class InsureProcessCar extends React.Component<IProps, IState> {
  readonly state = initState;
  private renewalInfo = (this.props.history.location.state as any)?.renewalInfo;

  // 定義一個預設的 IVehicleInfoFormValue，以確保型別安全
  private defaultIVehicleInfoFormValue: IVehicleInfoFormValue = {
    VEHICAL_MAKER: '',
    VEHICAL_LOSS_THEFT: false,
    MANUFACTUR_YEAR_MONTH: '',
    ORIGINAL_DATE_ISSUE: '',
    ORIGINAL_DATE_YEAR: '',
    ORIGINAL_DATE_MONTH: '',
    ORIGINAL_DATE_DATE: '',
    ENGINE_DISPLACEMENT: '',
    ENGINE_DISPLACEMENT_UNIT: '',
    VEHICAL_BRAND: '',
    VEHICAL_BRAND_NAME: '',
    VEHICAL_MODEL: '',
    VEHICAL_MODEL_NAME: '',
    REPLACEMENT_PRICE: '',
    LIMIT: '',
  };

  componentDidMount = async () => {
    if (this.props.match.params.uuid) {
      storageService.removeItem(storageKeys.InsurceProcessCarState);
      const boPaybyRes = await apiCommonService.boPayby(this.props.match.params.uuid);

      if (typeof boPaybyRes === 'string') {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: `${boPaybyRes}`
        }).then(() => {
          this.props.history.replace(RouterSettings.Home);
        });
        return;
      }

      const initSetting = await service.fetchInitSetting(InsType.Car);

      this.setState({
        insTypeId: boPaybyRes.INS_TYPE_ID,
        insTypeName: initSetting.inscat.INS_TYPE_NAME,
        prodId: boPaybyRes.PROD_ID,
        boPayby: { ...boPaybyRes },
        UICodes: [...initSetting.UICodes],
        vehicleCars: [...initSetting.vehicleCars],
        vehicleLimit: [...initSetting.vehicleLimit],
        nationalityVSysOpts: [...initSetting.nationalityVSysOpts],
        pNoFormat: [...initSetting.pNoFormat],
        step: insProcessCarStep.InsureProcessPayment
      });

      return;
    }

    // 險種
    let insTypeIdVal: string = InsType.Car;
    // 商品 Id
    let prodIdVal: string = '';
    // 專案代碼
    let programIdVal: string = '';
    if (storageService.getItem(storageKeys.CarActiveProdId)) {
      const temp = JSON.parse(storageService.getItem(storageKeys.CarActiveProdId)) as InsureProcessTemp;

      prodIdVal = temp.PROD_ID || '';
      insTypeIdVal = temp.INS_TYPE_ID || InsType.Car;
      programIdVal = temp.PROGRAM_ID || '';
    }
    // console.log('insTypeIdVal', insTypeIdVal);
    // console.log('prodIdVal', prodIdVal);
    // #region 判斷有無暫存資料

    // 有暫存資料且暫存資料已到期，刪除暫存資料
    if (storageService.getItem(storageKeys.InsurceProcessCarState)) {
      const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessCarState));

      const isChangeProdId = this.handleValidProdIdChange(insTypeIdVal, prodIdVal, tempData);

      if (isChangeProdId || moment().isAfter(tempData.expiredDate)) {
        storageService.removeItem(storageKeys.InsurceProcessCarState);
      }
    }

    const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessCarState));
    const loginInfo = storageService.getItem(storageKeys.LoginInfo);
    if (tempData && loginInfo) {
      const memberId = storageService.getItem(storageKeys.MemberId);
      // 判斷車主身分是否與登入者相同
      if (memberId) {
        commonService.validOwnerMathLoginID(
          tempData.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.MEMBER_ID, memberId, commonService.getCodeMsg(tempData.UICodes, CodeId.W033));
      }
    }

    if (tempData) {
      // console.log('設定暫存資料');
      this.setState({
        ...tempData,
        programId: tempData.programId ? tempData.programId : programIdVal
      });
      return;
    }

    // #endregion

    // prodIdVal = 'AP2';
    // insTypeIdVal = 'I02';
    const initSetting = await service.fetchInitSetting(InsType.Car);

    this.setState({
      insTypeName: initSetting.inscat.INS_TYPE_NAME,
      step: insProcessCarStep.InsureProcessVehicleOwnerInfo,
      UICodes: [...initSetting.UICodes],
      vehicleCars: [...initSetting.vehicleCars],
      vehicleLimit: [...initSetting.vehicleLimit],
      nationalityVSysOpts: [...initSetting.nationalityVSysOpts],
      pNoFormat: [...initSetting.pNoFormat],
      insTypeId: insTypeIdVal,
      prodId: prodIdVal,
      programId: programIdVal
    });

    // const initSettingRes = await service.fetchTempState();
    // this.setState({ ...initSettingRes });
  }

  /**
   * @description 判斷選取的方案是否改變，決定是否清除暫存
  */
  handleValidProdIdChange = (insTypeId: string, prodId: string, tempData: any) => {
    const selectState = tempData.tempSelect.tempSelectState as InprocessSelectState;

    // 未執行到商品選擇頁，判斷選取的商品卡片是否更改 或
    // 執行到商品選擇頁但未選擇方案
    if (!selectState || Object.keys(selectState).length === 0 || (selectState && !selectState.activeProdId)) {
      return insTypeId !== tempData.insTypeId || prodId !== tempData.prodId;
    }

    // activePlan activeProdId prodId
    // 執行到商品選擇頁，判斷選取的方案是否和商品卡片不符
    return insTypeId !== tempData.insTypeId || prodId !== selectState.activeProdId;
  }

  /**
    * @description 車主資料頁面結束事件
   */
  handleVehicleOwnerInfoUnmount = async (formVal: IVehicleOwnerInfoFormValue, state: IVehicleOwnerInfoState) => {
    const newState = {
      ...this.state,
      tempVehicleOwnerInfo: {
        tempVehicleOwnerInfoFormValue: { ...formVal },
        tempVehicleOwnerInfoState: { ...state }
      }
    };

    commonService.storageData(storageKeys.InsurceProcessCarState, newState);
  }

  /**
   * @description 自然人/法人 切換，清除暫存資料
   */
  handleVehicleOwnerInfoResetData = () => {
    this.setState({
      tempVehicleOwnerInfo: {},
      tempVehicleInfo: {},
      tempSelect: {},
      tempFill: {},
      tempPreview: {},
      tempPayment: {}
    });

    storageService.removeItem(storageKeys.InsurceProcessCarState);
    commonService.setActiveProdId(this.state.insTypeId, this.state.prodId);
  }

  /**
   * @description 清除 車籍頁暫存資料
   */
  handleResetTempVehicleInfo = () => {
    const newState = {
      ...this.state,
      tempVehicleInfo: {},
      tempSelect: {}
    };

    this.setState({ ...newState });

    storageService.removeItem(storageKeys.InsurceProcessCarState);
    commonService.storageData(storageKeys.InsurceProcessCarState, newState);
  }

  /**
   * @description 車主資料頁表單 submit 事件
  */
  handleVehicleOwnerInfoSubmit = async (formVal: IVehicleOwnerInfoFormValue, state: IVehicleOwnerInfoState) => {
    // 取得車主身分別、ID 判斷是否為自然人、是否為會員，判斷是否需要顯示登入訊息
    // const showLoginModal = await this.handleValidOwnerInfo(formVal.NATIONALITY_TYPE, formVal.MEMBER_ID);
    if (storageService.getItem(storageKeys.MemberId)) {
      // 判斷車主身分是否與登入者相同
      commonService.validOwnerMathLoginID(formVal.MEMBER_ID, storageService.getItem(storageKeys.MemberId), commonService.getCodeMsg(this.state.UICodes, CodeId.W033));
    }

    this.setState({
      step: insProcessCarStep.InsureProcessVehicalInfo,
      tempVehicleOwnerInfo: {
        tempVehicleOwnerInfoFormValue: { ...formVal },
        tempVehicleOwnerInfoState: { ...state }
      }
    });
    // 則呈現Lightbox提示 是否要登入? ，提供確定、取消供客戶執行
    // sweetAlertService.modal({
    // html: commonService.getCodeMsg(this.state.UICodes, CodeId.W007),
    // showCancelButton: true,
    // showCloseButton: true
    // }).then(async res => {
    //   if (res.value) {
    //     this.setState({
    //       step: insProcessCarStep.InsureProcessVehicalInfo,
    //       tempVehicleOwnerInfo: {
    //         tempVehicleOwnerInfoFormValue: { ...formVal },
    //         tempVehicleOwnerInfoState: { ...state }
    //       }
    //     });

    // const path = {
    //   pathname: RouterSettings.Login,
    //   state: { originUrl: RouterSettings.InsureProcess.Car }
    // };

    // this.props.history.push(path);
    //   }
    //   if (res.dismiss) {
    //     this.setState({
    //       step: insProcessCarStep.InsureProcessVehicalInfo,
    //       tempVehicleOwnerInfo: {
    //         tempVehicleOwnerInfoFormValue: { ...formVal },
    //         tempVehicleOwnerInfoState: { ...state }
    //       }
    //     });
    //   }
    // });
  }

  /**
   * @description 判斷車主身分別、ID 判斷是否為自然人、是否為會員，用來決定是否需要顯示登入訊息
  */
  handleValidOwnerInfo = async (nationalityType: string, memberID: string) => {
    if (nationalityType === NationalType.Legal) return false;

    return await memberProfileService.validMember(memberID);
  }

  /**
   * @description 車籍資料頁表單 submit 事件
  */
  handleVehicleInfoSubmit = async (formVal: IVehicleInfoFormValue, state: IVehicleInfoState) => {
    this.setState({
      step: insProcessCarStep.InsureProcessSelect,
      tempVehicleInfo: {
        tempVehicleInfoFormValue: { ...formVal },
        tempVehicleInfoState: { ...state }
      }
    });
  }

  /**
   * @description 車籍資料頁面結束事件
  */
  handleVehicleInfoUnmount = async (formVal: IVehicleInfoFormValue, state: IVehicleInfoState) => {
    const newState = {
      ...this.state,
      tempVehicleInfo: {
        tempVehicleInfoFormValue: { ...formVal },
        tempVehicleInfoState: { ...state }
      }
    };

    commonService.storageData(storageKeys.InsurceProcessCarState, newState);
  }

  /**
   * @description 車籍資料頁表單 返回 事件
  */
  handleVehicleInfoGoBack = (formVal: IVehicleInfoFormValue, state: IVehicleInfoState) => {
    this.setState({
      step: insProcessCarStep.InsureProcessVehicleOwnerInfo,
      tempVehicleInfo: {
        tempVehicleInfoFormValue: { ...formVal },
        tempVehicleInfoState: {
          ...state,
          renewVehicle: undefined
        }
      }
    });
  }

  /**
   * @description 商品選擇頁頁面結束事件
  */
  handleSelectUnmount = (formVal: InprocessSelectFormValue, state: InprocessSelectState) => {
    const newState = {
      ...this.state,
      step: this.state.step ? this.state.step : insProcessCarStep.InsureProcessFill,
      tempSelect: {
        tempSelectFormValue: { ...formVal },
        tempSelectState: { ...state }
      }
    };

    if (this.state.step === insProcessCarStep.InsureProcessFill) {
      pushGTM(this.getGtmArg('begin_checkout'));
    }

    commonService.storageData(storageKeys.InsurceProcessCarState, newState);
  }

  /**
   * @description 商品選擇頁回上一頁方法
  */
  handleSelectGoBack = (formVal: InprocessSelectFormValue, state: InprocessSelectState, activeProdId: string) => {
    this.setState({
      step: insProcessCarStep.InsureProcessVehicalInfo,
      tempSelect: {
        tempSelectFormValue: { ...formVal },
        tempSelectState: { ...state }
      },
      prodId: activeProdId
    });
  }

  /**                                                                                                                                                              
  * @description 商品選擇頁返回上一頁並勾選任意險
  */
  handleSelectGoBackAndCheckVoluntary = () => {
    // 取得當前或預設的車籍資料表單
    const currentVehicleInfoFormValue = this.state.tempVehicleInfo.tempVehicleInfoFormValue;
    // 取得當前或預設的車籍資料狀態值，如果沒有值就讓它保持 undefined
    const currentVehicleInfoState = this.state.tempVehicleInfo.tempVehicleInfoState;

    const newVehicleInfoFormValue: IVehicleInfoFormValue = {
      ...this.defaultIVehicleInfoFormValue, // 以預設值為基礎
      ...(currentVehicleInfoFormValue || {}), // 如果存在，則覆寫現有的值
      VEHICAL_LOSS_THEFT: true, // 自動勾選 ‘我要投保任意險’
      ENGINE_DISPLACEMENT: ''
    };

    const newState = {
      ...this.state,
      step: insProcessCarStep.InsureProcessVehicalInfo,
      tempVehicleInfo: {
        tempVehicleInfoFormValue: newVehicleInfoFormValue,
        tempVehicleInfoState: currentVehicleInfoState,
      }
    };
    this.setState(newState);
    commonService.storageData(storageKeys.InsurceProcessCarState, newState);
  }

  handleSelectCale = async (formVal: InprocessSelectFormValue, state: InprocessSelectState) => {
    this.setState({
      tempSelect: {
        tempSelectFormValue: { ...formVal },
        tempSelectState: { ...state }
      }
    });

    pushGTM(this.getGtmArg('add_to_cart'));
  }

  /**
   * @description 商品選擇頁表單 submit 事件
  */
  handleSelectSubmit = async (formVal: InprocessSelectFormValue, state: InprocessSelectState) => {
    const vehicleOwnerInfoFormVal = { ...this.state.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue } as IVehicleOwnerInfoFormValue;
    // 1. 若車主為法人，不提示訊息且前往下一頁
    if (vehicleOwnerInfoFormVal.NATIONALITY_TYPE === NationalType.Legal) {
      this.setState({
        step: insProcessCarStep.InsureProcessFill,
        tempSelect: {
          tempSelectFormValue: { ...formVal },
          tempSelectState: { ...state }
        }
      });

      return;
    }

    // 2. (自然人) 若已登入: 檢查車主與登入 ID
    if (storageService.getItem(storageKeys.MemberId)) {
      // 判斷車主身分是否與登入者相同
      let insuredError = false;
      if (state.validVehicleInsRuleRes.FORCE_BCTYPE_C) {
        insuredError = commonService.validOwnerMathLoginID(vehicleOwnerInfoFormVal.MEMBER_ID, storageService.getItem(storageKeys.MemberId), commonService.getCodeMsg(this.state.UICodes, CodeId.W031));
      }
      if (insuredError) return;

      // 車主與登入 ID 一致，不提示訊息且前往下一頁
      this.setState({
        step: insProcessCarStep.InsureProcessFill,
        tempSelect: {
          tempSelectFormValue: { ...formVal },
          tempSelectState: { ...state }
        }
      });

      return;
    }

    // 3. (自然人) 若未登入: 則判斷車主是否為會員，根據會員與否提示訊息並跳轉
    const showLoginModal = await this.handleValidOwnerInfo(vehicleOwnerInfoFormVal.NATIONALITY_TYPE, vehicleOwnerInfoFormVal.MEMBER_ID);
    let loginMsg = '';
    let signupMsg = '';
    let path: any;
    // 非會員提示註冊訊息
    if (!showLoginModal) {
      signupMsg = commonService.getCodeMsg(this.state.UICodes, CodeId.W010);
      path = {
        pathname: RouterSettings.Signup,
        state: { originUrl: RouterSettings.InsureProcess.Car }
      };
    }

    // 是會員提示登入
    if (showLoginModal) {
      loginMsg = `${commonService.getCodeMsg(this.state.UICodes, CodeId.W007)} <br /> ${commonService.getCodeMsg(this.state.UICodes, CodeId.W009)}`;
      path = {
        pathname: RouterSettings.Login,
        state: { originUrl: RouterSettings.InsureProcess.Car }
      };
    }

    // 則呈現 Lightbox提示 是否要登入/註冊? ，提供確定、取消供客戶執行
    sweetAlertService.modal({
      html: loginMsg || signupMsg,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: signupMsg ? '立即註冊' : '確認'
    }).then(async res => {
      if (res.value) {
        this.setState({
          step: 0 as insProcessCarStep,
          tempSelect: {
            tempSelectFormValue: { ...formVal },
            tempSelectState: { ...state }
          }
        });

        this.props.history.push(path);
      }
      if (res.dismiss) {
        this.setState({
          step: insProcessCarStep.InsureProcessFill,
          tempSelect: {
            tempSelectFormValue: { ...formVal },
            tempSelectState: { ...state }
          }
        });
      }
    });
  }

  /**
   * @description 商品選擇頁選擇商品為限制 網投 (C) 時，進行登入
  */
  handleSelectItemLogin = () => {
    const path = {
      pathname: RouterSettings.Login,
      state: { originUrl: RouterSettings.InsureProcess.Car }
    };

    setTimeout(() => {
      this.props.history.push(path);
    });
  }

  /**
   * @description 資料填寫頁頁面結束事件
  */
  handleFillUnmount = (formVal: InsureProcessFillFormValue, state: InsureProcessFillState) => {
    if (this.state.isBirthdayErr) return;

    const newState = {
      ...this.state,
      step: this.state.step ? this.state.step : insProcessCarStep.InsureProcessFill,
      tempFill: {
        tempFillFormValue: { ...formVal },
        tempFillState: { ...state }
      }
    };

    commonService.storageData(storageKeys.InsurceProcessCarState, newState);
  }

  /**
   * @description 資料填寫頁返回上一頁方法
  */
  handleFillGoBack = (formVal: InsureProcessFillFormValue, state: InsureProcessFillState) => {
    this.setState({
      step: insProcessCarStep.InsureProcessSelect,
      tempFill: {
        tempFillFormValue: { ...formVal },
        tempFillState: { ...state }
      }
    });
  }

  /**
   * @description 資料填寫頁表單 submit 事件
  */
  handleFillSubmit = (formVal: InsureProcessFillFormValue, state: InsureProcessFillState) => {
    this.setState({
      step: insProcessCarStep.InsureProcessPreview,
      tempFill: {
        tempFillFormValue: { ...formVal },
        tempFillState: { ...state }
      },
      tempVehicleOwnerInfo: {
        ...this.state.tempVehicleOwnerInfo,
        tempVehicleOwnerInfoFormValue: {
          ...this.state.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue as IVehicleOwnerInfoFormValue,
          MEMBER_ID: formVal.INSURED_MEMBER_ID,
          BIRTHDAY: formVal.INSURED_BIRTHDAY,
          NATIONALITY_TYPE: formVal.INSURED_NATIONALITY_TYPE
        }
      }
    });
  }

  /**
   * @description 資料填寫頁登入事件
   */
  handleFillLogin = (formVal: InsureProcessFillFormValue, state: InsureProcessFillState) => {
    this.setState({
      step: 0 as insProcessCarStep,
      tempFill: {
        tempFillFormValue: { ...formVal },
        tempFillState: { ...state }
      },
      tempVehicleOwnerInfo: {
        ...this.state.tempVehicleOwnerInfo,
        tempVehicleOwnerInfoFormValue: {
          ...this.state.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue as IVehicleOwnerInfoFormValue,
          MEMBER_ID: formVal.INSURED_MEMBER_ID,
          BIRTHDAY: formVal.INSURED_BIRTHDAY,
          NATIONALITY_TYPE: formVal.INSURED_NATIONALITY_TYPE
        }
      }
    });

    const path = {
      pathname: RouterSettings.Login,
      state: { originUrl: RouterSettings.InsureProcess.Car }
    };

    this.props.history.push(path);
  }

  /**
   * @description 資料填寫頁生日檢核失敗事件
   */
  handleBirthdayError = () => {
    storageService.removeItem(storageKeys.InsurceProcessCarState);
    storageService.removeItem(storageKeys.CarActiveProdId);

    this.setState(state => {
      return {
        ...state,
        isBirthdayErr: true
      };
    });

    this.props.history.push(RouterSettings.Product.CarIns);
  }

  /**
   * @description 資料預覽頁頁面結束事件
  */
  handlePreviewUnmount = async (formVal: IVehiclePreviewFormValue, state: IVehiclePreviewState) => {
    const newState = {
      ...this.state,
      tempPreview: {
        tempPreviewFormValue: { ...formVal },
        tempPreviewState: { ...state }
      }
    };

    commonService.storageData(storageKeys.InsurceProcessCarState, newState);
  }

  /**
   * @description 資料預覽頁點選下一步事件
  */
  handlePreviewSubmit = async (formVal: IVehiclePreviewFormValue, state: IVehiclePreviewState, policyAddReq: any) => {
    const applyType: string = this.state.tempFill.tempFillState?.applyType || '';
    this.setState({
      policyAddReq
    });

    // console.log({ applyType });
    // console.log('policyAddReq', policyAddReq);

    // 案件來源為網投進行 OTP 驗證後再導至付款頁
    if (applyType === ApplyType.WebInsured) {
      this.setState({
        tempPreview: {
          tempPreviewFormValue: { ...formVal },
          tempPreviewState: { ...state }
        }
      });
      // 進行 OTP
      await this.handleFetchOTP(false, policyAddReq);
      return;
    }

    this.setState({
      tempPreview: {
        tempPreviewFormValue: { ...formVal },
        tempPreviewState: { ...state }
      }
    });

    // 案件來源為網要，不用 OTP 驗證: 新增保單 --> 導至付款頁
    if (applyType === ApplyType.WebRequire && policyAddReq) {
      this.setState({
        tempPreview: {
          tempPreviewFormValue: { ...formVal },
          tempPreviewState: { ...state }
        }
      });
      //* 新增保單
      const res = await service.addVehicle(policyAddReq);
      if (!res) return;
      // 新增保單完成後，清除 F14-079 上行電文資料
      storageService.removeItem(storageKeys.Vehregdata);
      //* 導至付款頁
      await this.handleSetStepPayment();
    };
  }

  /**
   * @description 資料預覽頁點選返回事件
  */
  handlePreviewGoBack = (formVal: IVehiclePreviewFormValue, state: IVehiclePreviewState) => {
    this.setState({
      step: insProcessCarStep.InsureProcessFill,
      tempPreview: {
        tempPreviewFormValue: { ...formVal },
        tempPreviewState: { ...state }
      }
    });
  }

  /**
   * @description 導頁至確認付款頁
  */
  handleSetStepPayment = () => {
    this.setState({
      step: insProcessCarStep.InsureProcessPayment
    });
  }

  /**
   * @description 取得 OTP 驗證碼方法
   * @param memberProfile 會員基本資料
   * @param isReSent 是否為重新發送
   * @param policyAddReq 打新增保單的 req
  */
  handleFetchOTP = async (isReSent?: boolean, policyAddReq?: any) => {
    const tempFillFormVal = { ...this.state.tempFill.tempFillFormValue } as InsureProcessFillFormValue;
    const memberId = tempFillFormVal.INSURED_MEMBER_ID;
    const mobile = tempFillFormVal.INSURED_MOBILE;
    const emailAddr = tempFillFormVal.INSURED_EMAIL;

    const result = await apiCommonService.fetchOTP({ MEMBER_ID: memberId, MOBILE: mobile, EMAIL_ADDR: emailAddr } as MemberProfile, SactionType.Insurce, isReSent);
    if (result) {
      this.setState({
        step: insProcessCarStep.InsureProcessVerifyOTP,
        otpInfo: { ...result.TRANRS },
        getOTPTime: new Date().getTime(),
        policyAddReq
      });
    }
  }

  /**
   * @description OTP 驗證碼頁面點選返回上一頁或無法取得驗證碼時的方法
   */
  handleReSetProfile = () => {
    this.setState({
      step: insProcessCarStep.InsureProcessPreview,
      otpInfo: undefined,
      getOTPTime: undefined
    });
  };

  /**
   * @description 驗證 OTP 驗證碼方法
   * @param otpVerificationReq OTP 驗證頁 Request Model
  */
  handleVerifyOTP = async (otpCode: string) => {
    const result = await apiCommonService.verifyOTP(this.state.otpInfo as OTPInfo, otpCode, SactionType.Insurce, false);

    if (typeof result === 'string') {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '驗證碼輸入有誤'// 'OTP驗證失敗',
        // html: result
      });

      return;
    }

    if (result && this.state.policyAddReq) {
      //* 在這邊才 service.addVehicle(policyAddReq)
      const res = await service.addVehicle(this.state.policyAddReq);
      if (!res) return;
      // 新增保單完成後，清除 F14-079 上行電文資料
      storageService.removeItem(storageKeys.Vehregdata);
      await this.handleSetStepPayment();
    }
  }

  /**
   * @description 確認付款頁頁面結束事件
  */
  handlePaymentUnmount = async (formVal: IPaymentFormValue, state: IPaymentState) => {
    const newState = {
      ...this.state,
      tempPayment: {
        tempPaymentFormValue: { ...formVal },
        tempPaymentState: { ...state }
      }
    };

    commonService.storageData(storageKeys.InsurceProcessCarState, newState);
  }

  /**
   * @description 確認付款頁表單 submit 事件
  */
  handlePaymentSubmit = async (formVal: IPaymentFormValue, state: IPaymentState) => {
    const activityInfo = await service.fetchActivities(InsType.Car);

    this.setState({
      step: insProcessCarStep.InsureProcessSuccess,
      tempPayment: {
        tempPaymentFormValue: { ...formVal },
        tempPaymentState: { ...state }
      },
      activities: { ...activityInfo.activities }
    });

    pushGTM(this.getGtmArg('purchase'));

    storageService.removeItem(storageKeys.InsurceProcessCarState);
    storageService.removeItem(storageKeys.CarActiveProdId);
  }

  /**
   * @description 確認付款頁 返回 事件
  */
  handlePaymentGoBack = () => {
    this.setState({
      step: insProcessCarStep.InsureProcessPreview
      // tempPayment: {
      //   tempPaymentFormValue: { ...formVal },
      //   tempPaymentState: { ...state }
      // }
    });
  }

  /**
    * @description 成功投保頁，顯示熱門活動 Slider
   */
  handleCreateSlider = () => {
    let sliderBar;
    if (this.state.activities && this.state.activities.ACTIVITY.length > 0) {
      const child = _.map(this.state.activities.ACTIVITY, (activity: Activity, index: number) => {
        return (
          <SliderBoundless.Item key={index}>
            <a href={activity.ACTIVITY_URL} target="_blank" rel="noopener noreferrer">
              <img src={activity.IMAGE_NAME_PC} alt={activity.TITLE} />
            </a>
          </SliderBoundless.Item>
        );
      });
      sliderBar = (
        <div>
          <div className="insure-process__slider-section">
            <SliderBoundless name="insure-process__slider">
              {child}
            </SliderBoundless>
          </div>
        </div>
      );
    }

    return sliderBar;
  }

  handleItemConstrain = (
    constrain?: ConstrainContent, fidType?: string, item?: any, selevtVal?: any) => {
    if (!constrain) return '';

    if (constrain.CRITERIA) {
      const vehicleInfoFormValue = { ...this.state.tempVehicleInfo.tempVehicleInfoFormValue } as IVehicleInfoFormValue;
      // const diffYear = moment().diff(moment(vehicleInfoFormValue.MANUFACTUR_YEAR_MONTH), 'y');
      const diffYear = moment().year() - moment(vehicleInfoFormValue.MANUFACTUR_YEAR_MONTH).year();

      let res = '';

      let criteria = _.find(constrain.CRITERIA, (criteria: CriteriaContent) => diffYear < criteria.MAX && !criteria.MIN && criteria.ACTION === 'INVISIBLE');
      if (criteria) {
        res = criteria.ACTION;
      }

      criteria = _.find(constrain.CRITERIA, (criteria: CriteriaContent) => diffYear >= criteria.MIN && diffYear < criteria.MAX && criteria.ACTION === 'ALERT');
      if (criteria) {
        res = criteria.TEXT;
      }

      criteria = _.find(constrain.CRITERIA, (criteria: CriteriaContent) => diffYear >= criteria.MIN && !criteria.MAX && criteria.ACTION === 'ALERT');
      if (criteria) {
        res = criteria.TEXT;
      }

      return res;
    }

    return '';
  }

  /**
   * @description 取得有投保的保障內容資料
   */
  handleFetchInsuredPolicys = (policyItemList: PolicyItemListContent[]) => {
    const insuredPolicy = new Array(0);

    _.forEach(policyItemList, (policyItem: PolicyItemListContent) => {
      _.forEach(policyItem.MAIN_ITEMS, (mainItem: any) => {
        const constrainRes = this.handleItemConstrain(mainItem.CONSTRAIN);
        if (constrainRes === 'INVISIBLE') return;

        if (mainItem.CHECKED) {
          insuredPolicy.push({
            ...mainItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(mainItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });

      _.forEach(policyItem.SUB_ITEMS, (subItem: any) => {
        const constrainRes = this.handleItemConstrain(subItem.CONSTRAIN);
        if (constrainRes === 'INVISIBLE') return;

        if (subItem.CHECKED) {
          insuredPolicy.push({
            ...subItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(subItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });
    });

    return insuredPolicy;
  }

  getGtmArg = (event:string): DataLayerArgs => {
    const planItems = [...this.state.tempSelect.tempSelectFormValue?.POLICY_ITEM ?? []];
    // 取得有投保的項目
    const insuredPolicys = this.handleFetchInsuredPolicys(planItems);

    return {
      dataLayer: {
        event: 'td_' + event,
        ga4_event_name: event,
        ecommerce: {
          ...event === 'purchase' ? {
            coupon: this.state.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.PROGRAM_ID || null,
            transaction_id: this.state.tempFill.tempFillState?.serialNo,
            affiliation: helperArgGTM.getAffiliation,
            payment_method: helperArgGTM.getPaymentMethodText(this.state.tempPayment.tempPaymentFormValue?.PAYMENT_METHOD)
          } : {},
          currency: helperArgGTM.getCurrency,
          value: commonService.getVehiclePrenium(this.state.tempSelect.tempSelectState?.evalCarRes?.SUMPREMIUM[1]?.SUMPREMIUM, this.state.tempSelect.tempSelectState?.evalCarRes?.SUMPREMIUM[1]?.SUMPREMIUMCI),
          items: insuredPolicys.map((item: any) => ({
            item_id: item.ITEM_ID,
            item_name: item.ITEM_NAME,
            affiliation: helperArgGTM.getAffiliation,
            coupon: this.state.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.PROGRAM_ID || null,
            currency: helperArgGTM.getCurrency,
            item_brand: this.state.insTypeName,
            item_category: this.state.tempSelect.tempSelectState?.policyItem.find((policyItem: any) => policyItem.ITEM_TYPE === item.ITEM_TYPE)?.ITEM_TYPE_NAME || '',
            item_category2: helperArgGTM.getRenewOrNewText(this.state.policyAddReq?.IPOLICY),
            item_category3: helperArgGTM.getBcTypeText(this.state.policyAddReq?.BC_TYPE),
            item_variant: item.ITEM_OPTION?.reduce((variant: string, cur: any) => {
              if (cur.TYPE === 'TEXT') {
                return variant + cur.VALUE;
              }
              if (cur.TYPE === 'OPTION') {
                return variant + cur.SELECT_TEXT;
              }
              return variant;
            }, ''),
            price: this.state.tempSelect.tempSelectState?.evalCarRes.POLICY_ITEM_LIST
                .find((policyItem: any) => policyItem.KINDCODE === item.ITEM_ID)
                ?.PREMIUM[1].PREMIUM || 0,
            quantity: 1,
            item_list_name: this.state.tempSelect.tempSelectState?.activePlanName
          }))
        }
      }
    };
  }

  render () {
    const { step } = this.state;

    const tempFillFormVal = { ...this.state.tempFill.tempFillFormValue } as InsureProcessFillFormValue;
    const memberId = tempFillFormVal.INSURED_MEMBER_ID;
    const mobile = tempFillFormVal.INSURED_MOBILE;
    const emailAddr = tempFillFormVal.INSURED_EMAIL;

    const stepElems: IStepElems[] = [
      {
        icon: insProcessCarStepIcon.carIcon,
        text: '車籍資料',
        active: step >= insProcessCarStep.InsureProcessVehicleOwnerInfo || step >= insProcessCarStep.InsureProcessVehicalInfo,
        mobileActive: step === insProcessCarStep.InsureProcessVehicleOwnerInfo || step === insProcessCarStep.InsureProcessVehicalInfo
      },
      {
        icon: insProcessCarStepIcon.selectIcon,
        text: '選擇商品',
        active: step >= insProcessCarStep.InsureProcessSelect,
        mobileActive: step === insProcessCarStep.InsureProcessSelect
      },
      {
        icon: insProcessCarStepIcon.fillIcon,
        text: '填寫資料',
        active: step >= insProcessCarStep.InsureProcessFill,
        mobileActive: step === insProcessCarStep.InsureProcessFill
      },
      {
        icon: insProcessCarStepIcon.previewIcon,
        text: '資料預覽',
        active: step >= insProcessCarStep.InsureProcessPreview,
        mobileActive: step === insProcessCarStep.InsureProcessPreview
      },
      {
        icon: insProcessCarStepIcon.paymentIcon,
        text: '確認付款',
        active: step >= insProcessCarStep.InsureProcessPayment,
        mobileActive: step === insProcessCarStep.InsureProcessPayment
      },
      {
        icon: insProcessCarStepIcon.successIcon,
        text: '成功投保',
        active: step >= insProcessCarStep.InsureProcessSuccess,
        mobileActive: step === insProcessCarStep.InsureProcessSuccess
      }
    ];

    let activeStepPage;
    let successSlider = null; // 成功投保 - Slider
    switch (step) {
      case insProcessCarStep.InsureProcessVehicleOwnerInfo:
        /* 車籍資料 (第一頁 - 車主資料) */
        activeStepPage = (
          <InsureProcessVehicleOwnerInfo
            prodId={this.state.prodId}
            insTypeId={this.state.insTypeId}
            programId={this.state.programId}
            UICodes={this.state.UICodes}
            nationalityVSysOpts={this.state.nationalityVSysOpts}
            vehicleCars={this.state.vehicleCars}
            tempVehicleOwnerInfo={this.state.tempVehicleOwnerInfo}
            tempVehicleInfo={this.state.tempVehicleInfo}
            onVehicleOwnerInfoSubmit={this.handleVehicleOwnerInfoSubmit}
            onUnmount={this.handleVehicleOwnerInfoUnmount}
            onResetTempData={this.handleVehicleOwnerInfoResetData}
            onResetTempVehicleInfo={this.handleResetTempVehicleInfo}
            renewalInfo={this.renewalInfo}
          />
        );
        break;
      case insProcessCarStep.InsureProcessVehicalInfo:
        /* 車籍資料 (第二頁 - 車籍資料) */
        activeStepPage = (
          <InsureProcessVehicalInfo
            type={InsTypeDefinesEN[InsType.Car]}
            insTypeId={this.state.insTypeId}
            onGoBack={this.handleVehicleInfoGoBack}
            UICodes={this.state.UICodes}
            tempVehicleOwnerInfo={this.state.tempVehicleOwnerInfo}
            tempVehicleInfo={this.state.tempVehicleInfo}
            tempState={this.state}
            vehicleCars={this.state.vehicleCars}
            onVehicleInfoSubmit={this.handleVehicleInfoSubmit}
            onUnmount={this.handleVehicleInfoUnmount}
            renewalInfo={this.renewalInfo}
            vehicleLimit={this.state.vehicleLimit}
            pNoFormat={this.state.pNoFormat}
          />
        );
        break;
      case insProcessCarStep.InsureProcessSelect:
        /* 選擇商品 */
        activeStepPage = (
          <InsureProcessSelect
            type={InsTypeDefinesEN[InsType.Car]}
            insTypeId={this.state.insTypeId}
            insTypeName={this.state.insTypeName}
            prodId={this.state.prodId}
            UICodes={this.state.UICodes}
            tempVehicleOwnerInfo={this.state.tempVehicleOwnerInfo}
            tempVehicleInfo={this.state.tempVehicleInfo}
            tempSelect={this.state.tempSelect}
            tempState={this.state}
            onSelectCale={this.handleSelectCale}
            onSelectSubmit={this.handleSelectSubmit}
            onSelectItemLogin={this.handleSelectItemLogin}
            onGoBack={this.handleSelectGoBack}
            onUnmount={this.handleSelectUnmount}
            onGoBackAndCorrectVehicleInfo={this.handleSelectGoBackAndCheckVoluntary}
          />
        );
        break;
      case insProcessCarStep.InsureProcessFill:
        /* 填寫資料 */
        activeStepPage = (
          <InsureProcessFill
            insTypeId={this.state.insTypeId}
            UICodes={this.state.UICodes}
            nationalityVSysOpts={this.state.nationalityVSysOpts}
            tempVehicleOwnerInfo={this.state.tempVehicleOwnerInfo}
            tempVehicleInfo={this.state.tempVehicleInfo}
            tempSelect={this.state.tempSelect}
            tempFill={this.state.tempFill}
            onGoBack={this.handleFillGoBack}
            onFillSubmit={this.handleFillSubmit}
            tempState={this.state}
            onUnmount={this.handleFillUnmount}
            onLogin={this.handleFillLogin}
            onBirthdayError={this.handleBirthdayError}
          />
        );
        break;
      case insProcessCarStep.InsureProcessPreview:
        /* 資料預覽 */
        activeStepPage = (
          <InsureProcessPreview
            insTypeId={this.state.insTypeId}
            tempVehicleOwnerInfo={this.state.tempVehicleOwnerInfo}
            tempVehicleInfo={this.state.tempVehicleInfo}
            tempSelect={this.state.tempSelect}
            tempFill={this.state.tempFill}
            onPreviewSubmit={this.handlePreviewSubmit}
            onGoBack={this.handlePreviewGoBack}
            tempPreview={this.state.tempPreview}
            tempState={this.state}
            onUnmount={this.handlePreviewUnmount}
          />
        );
        break;
      case insProcessCarStep.InsureProcessVerifyOTP:
        activeStepPage = <OTPVerificationForm
          memberProfile={{ MEMBER_ID: memberId, MOBILE: mobile, EMAIL_ADDR: emailAddr } as MemberProfile}
          memberId={memberId}
          otpInfo={this.state.otpInfo as OTPInfo}
          getOTPTime={this.state.getOTPTime as number}
          UICode={this.state.UICodes as Code[]}
          onUnavailableAuth={this.handleReSetProfile}
          onGoBack={this.handleReSetProfile}
          onSubmit={this.handleVerifyOTP}
          onResentOTP={() => this.handleFetchOTP(true)}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case insProcessCarStep.InsureProcessPayment:
        /* 確認付款 */
        activeStepPage = (
          <InsureProcessPayment
            insTypeId={this.state.insTypeId}
            UICodes={this.state.UICodes}
            tempFill={this.state.tempFill}
            tempSelect={this.state.tempSelect}
            tempState={this.state}
            tempPayment={this.state.tempPayment}
            onPaymentSubmit={this.handlePaymentSubmit}
            onGoBack={this.handlePaymentGoBack}
            onUnmount={this.handlePaymentUnmount}
            boPayby={this.state.boPayby}
          />
        );
        break;
      case insProcessCarStep.InsureProcessSuccess:
        /* 成功投保 */
        activeStepPage = (
          <InsureProcessSuccess
            insTypeId={this.state.insTypeId}
            UICodes={this.state.UICodes}
            tempVehicleOwnerInfo={this.state.tempVehicleOwnerInfo}
            tempFill={this.state.tempFill}
            tempSelect={this.state.tempSelect}
            tempState={this.state}
            tempPayment={this.state.tempPayment}
            boPayby={this.state.boPayby}
          />
        );

        successSlider = this.handleCreateSlider();
        break;
    }

    return (
      <div className={`insure-process insure-process--${InsTypeDefinesEN[InsType.Car]}`}>
        <div className="insure-process__header">
          <ProcessBar
            insType={InsTypeDefinesEN[InsType.Car]}
            stepElems={stepElems}
          />
        </div>
        <div className="insure-process__content">
          <div className="template-container">
            <div className="template-content">
              {activeStepPage}
            </div>
          </div>
        </div>

        {/* 成功投保 - Slider */}
        {successSlider}
      </div>
    );
  }
}

export default InsureProcessCar;
